import * as React from "react";
import styled from 'styled-components';

import {headline1} from '../../typography';
import {ReactNode} from "react";

type IHeadline = {
  children?: ReactNode,
}

const HeadlineStyled = styled.h1`
  ${headline1}
`;

const Headline = ({
  children,
}: IHeadline) => (
  <HeadlineStyled>
    {children}
  </HeadlineStyled>
)

export default Headline;
